import { observable } from "mobx";
import ExemptionCancellationRejectionReason from "./exemptionCancellationRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionCancellationActionResponse {
  /**
   * Indicates if action on charge is allowed.
   */
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: ExemptionCancellationRejectionReason;
}
